<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Solicitar Outra Ação</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestOther">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column is-one-third">
            <b-field label="Tipo da Ação *">
              <b-field style="padding-top: 8px">
                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="true"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Online</span>
                </b-radio>

                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="false"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Presencial</span>
                </b-radio>
                <span @click="formatAlert" v-if="hasFormat">
                  <b-icon
                    type="is-info"
                    icon="info-circle"
                    class="format-icon"
                  ></b-icon>
                </span>
              </b-field>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="request.eventInfo.eventType ? 'Ação desejada *' : ''"
              label-position="on-border"
            >
              <b-select expanded v-model="request.eventInfo.eventType">
                <option value="">Selecione a ação desejada</option>
                <option value="Concurso">Concurso</option>
                <option value="Desafio">Desafio</option>
                <option value="Hackathon">Hackathon</option>
                <option value="Mesa-redonda">Mesa-redonda</option>
                <option value="Outra">Outra</option>
              </b-select>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="request.eventInfo.attendeeQty ? 'Público estimado *' : ''"
              label-position="on-border"
            >
              <b-input
                type="number"
                placeholder="Público estimado *"
                v-model="request.eventInfo.attendeeQty"
              ></b-input>
            </b-field>
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.studentsCourses.length
              ? 'Cursos dos estudantes *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.studentsCourses"
            :data="coursesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Cursos dos estudantes *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          v-show="isAnotherAction"
          :label="request.eventInfo.anotherAction ? 'Qual outra ação?' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="request.eventInfo.anotherAction"
            placeholder="Qual outra ação?"
          ></b-input>
        </b-field>

        <date-options />

        <b-field
          :label="
            request.eventInfo.eventDescription
              ? 'Descrição da ação solicitada *'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Descrição da ação solicitada"
            v-model="request.eventInfo.eventDescription"
          />
        </b-field>
        <span
          :style="descriptionLength >= 140 ? 'color: green' : 'color: red'"
          style="display: table; margin-left: auto"
        >
          {{ descriptionLength }} > 140
        </span>

        <b-field label="Se desejar, anexe um material de suporte em PDF">
          <b-field>
            <div class="columns">
              <div class="column is-narrow">
                <button
                  type="button"
                  class="button is-empower-gray"
                  @click="$refs.pdf_other.click()"
                >
                  Anexar PDF (max. 5mb)
                </button>
                <input
                  id="pdf_other"
                  type="file"
                  ref="pdf_other"
                  style="display: none"
                  @change="handleFileUpload()"
                />
              </div>

              <div class="column">
                <p
                  v-if="filename"
                  :style="[!isMobile ? { 'margin-top': '0.4rem' } : null]"
                >
                  ✅ {{ filename }}&nbsp;
                  <a class="delete is-medium" @click="excludeFile"></a>
                </p>
              </div>
            </div>
          </b-field>
        </b-field>

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey "
        >
          <div class="field">
            <b-checkbox v-model="terms.form">
              Aceito enviar o formulário disponibilizado pela Empower a todos os
              participantes da ação.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos da ação e coletar as devidas
              autorizações para uso de imagem dos participantes que aparecerem
              nos prints/fotos enviados.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin da OE.
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            :disabled="pendencies.length || isLoading"
            class="button is-primary"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Outra Ação
          </button>
        </div>
        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { request } from "../../../mixins/request";
import { cursos } from "../../../assets/js/cursos";
import dateOptions from "./date-time-options/DateOptions";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive, request],

  components: {
    dateOptions,
    Pendencies,
  },

  props: ["advance"],

  data() {
    const today = new Date();
    return {
      isLoading: false,

      minDate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + this.advance * 7
      ),

      hasFormat: false,

      request: {
        opportunity: null,
        requestType: "other",
        eventInfo: {
          eventType: "",
          anotherAction: "",
          eventDescription: "",
          isOnline: "",
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null,
            },
            second: {
              date: null,
              start: null,
              end: null,
            },
            third: {
              date: null,
              start: null,
              end: null,
            },
          },
          attendeeQty: null,
          studentsCourses: []
        },
      },

      pdf_other: "",
      filename: "",
      terms: {
        form: false,
        photos: false,
        post: false,
      },
      coursesArray: []
    };
  },

  methods: {
    handleFileUpload() {
      this.filename = this.$refs.pdf_other.files[0].name;
      this.pdf_other = this.$refs.pdf_other.files[0];
    },

    excludeFile() {
      this.filename = "";
      this.pdf_lecture = "";
    },

    requestOther() {
      if (this.pdf_other.size > 5000000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE" });
        return;
      }

      this.request.eventInfo.dateOptions.first.start =
        this.request.eventInfo.dateOptions.first.date;
      this.request.eventInfo.dateOptions.first.end =
        this.request.eventInfo.dateOptions.first.date;

      this.request.eventInfo.dateOptions.second.start =
        this.request.eventInfo.dateOptions.second.date;
      this.request.eventInfo.dateOptions.second.end =
        this.request.eventInfo.dateOptions.second.date;

      this.request.eventInfo.dateOptions.third.start =
        this.request.eventInfo.dateOptions.third.date;
      this.request.eventInfo.dateOptions.third.end =
        this.request.eventInfo.dateOptions.third.date;

      let formData = new FormData();
      formData.append("pdf_other", this.pdf_other);
      formData.append("request", JSON.stringify(this.request));

      this.isLoading = true;
      this.$store
        .dispatch("makeRequest", {
          to: "other",
          data: formData,
        })
        .then((res) => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação de Ação Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close(),
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    formatAlert() {
      this.$buefy.dialog.alert(
        "Esta empresa realiza outras ações apenas neste formato."
      );
    },
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"]),

    isAnotherAction() {
      return this.request.eventInfo.eventType === "Outra";
    },

    pendencies() {
      const pendencies = [];

      if (!this.terms.form || !this.terms.photos || !this.terms.post) {
        pendencies.push("Aceitar termos de contrapartidas");
      }

      if (this.request.eventInfo.isOnline === "") {
        pendencies.push("Tipo de ação");
      }

      if (this.request.eventInfo.studentsCourses.length < 1) {
        pendencies.push("Informe os cursos dos estudantes");
      }

      if (!this.request.eventInfo.eventType) {
        pendencies.push("Selecione a ação desejada");
      } else if (
        this.isAnotherAction &&
        !this.request.eventInfo.anotherAction
      ) {
        pendencies.push("Qual outra ação?");
      }

      if (!this.request.eventInfo.attendeeQty) {
        pendencies.push("Público estimado");
      }

      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Primeira opção de data");
      }

      if (!this.request.eventInfo.dateOptions.second.date) {
        pendencies.push("Segunda opção de data");
      }

      if (!this.request.eventInfo.dateOptions.third.date) {
        pendencies.push("Terceira opção de data");
      }

      if (!this.request.eventInfo.eventDescription) {
        pendencies.push("Descrição da ação solicitada");
      } else if (this.request.eventInfo.eventDescription.length < 140) {
        pendencies.push("A descrição precisa ter no mínimo 140 caracteres");
      }

      return pendencies;
    },

    descriptionLength() {
      return this.request.eventInfo.eventDescription.length;
    },
  },

  mounted() {
    this.coursesArray = cursos;
    
    this.request.opportunity = this.opportunityBeingVisited._id;

    if (this.opportunityBeingVisited.other.format) {
      if (this.opportunityBeingVisited.other.format == "online") {
        this.request.eventInfo.isOnline = true;
        this.hasFormat = true;
      } else if (this.opportunityBeingVisited.other.format == "faceToFace") {
        this.request.eventInfo.isOnline = false;
        this.hasFormat = true;
      }
    }
  },
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}

.format-icon {
  cursor: pointer;
}
</style>
